<template>
  <v-app>
    <v-content>
      <common-header />
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import CommonHeader from '@/components/CommonHeader'

export default {
  name: 'app',
  components: {
    CommonHeader
  },
  created () {
    this.$i18n.locale = this.$storage.get('locale', this.$i18n.locale)
  }
}
</script>

<style lang="scss">
html, body {
  height: 100%;
}
body {
  margin: 0;
  background-color: rgb(35, 172, 56);
  display: flex;
  justify-content: center;
}
#app {
  font-family: sans-serif;
  background-color: rgb(35, 172, 56);
  color: black;
  max-width: 500px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
